// general
const Error = () => import("@/views/general/Error");
// public
const Login = () => import("@/views/public/Login");
const ResetPassword = () => import("@/views/public/ResetPassword");
const LupaPassword = () => import("@/views/public/LupaPassword");
const TentangAplikasi = () => import("@/views/public/TentangAplikasi");
const KebijakanPrivasi = () => import("@/views/public/KebijakanPrivasi");
// private
const Dashboard = () => import("@/views/private/Dashboard");
const LaporanTraining = () => import("@/views/private/LaporanTraining");
const LaporanTrainer = () => import("@/views/private/LaporanTrainer");
const LaporanClient = () => import("@/views/private/LaporanClient");
const Materi = () => import("@/views/private/Materi");
const Trainer = () => import("@/views/private/Trainer");
const TrainerDivisi = () => import("@/views/private/TrainerDivisi");
const Training = () => import("@/views/private/Training");
const Client = () => import("@/views/private/Client");
const ClientArea = () => import("@/views/private/ClientArea");
const User = () => import("@/views/private/User");
const Sistem = () => import("@/views/private/Sistem");

const Profil = () => import("@/views/private/Profil");

const routes = [
  // PUBLIC LAYOUT
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      public: true
    }
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      public: true,
      title: "Reset Password"
    }
  },
  {
    path: "/lupa-password",
    name: "LupaPassword",
    component: LupaPassword,
    meta: {
      public: true,
      title: "Lupa Password"
    }
  },
  {
    path: "/tentang-aplikasi",
    name: "TentangAplikasi",
    component: TentangAplikasi,
    meta: {
      public: true,
      title: "Tentang Aplikasi"
    }
  },
  {
    path: "/kebijakan-privasi",
    name: "KebijakanPrivasi",
    component: KebijakanPrivasi,
    meta: {
      public: true,
      title: "Kebijakan Privasi"
    }
  },
  // ERROR PAGE
  {
    path: "/404",
    name: "NotFound",
    component: Error,
    meta: {
      public: true,
      filter: {},
      error: {
        code: 404,
        message: "Maaf, halaman tidak ditemukan!"
      }
    }
  },
  {
    path: "/403",
    name: "AccessDenied",
    component: Error,
    meta: {
      public: true,
      filter: {},
      error: {
        code: 403,
        message: "Maaf, akses ditolak!"
      }
    }
  },
  {
    path: "/500",
    name: "ServerError",
    component: Error,
    meta: {
      public: true,
      filter: {},
      error: {
        code: 500,
        message: "Maaf, server sedang down."
      }
    }
  },
  // PRIVATE LAYOUT
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      filter: {
        laman: true,
        periode: true
      },
      role: ["ADMIN", "TRAINING", "DIREKSI"]
    }
  },
  {
    path: "/laporan/training",
    name: "LaporanTraining",
    component: LaporanTraining,
    meta: {
      title: "Laporan Training",
      filter: {
        periode: true
      },
      primary_field: "pel_client",
      noBreadcrumbs: true,
      role: ["ADMIN", "TRAINING", "DIREKSI"]
    }
  },
  {
    path: "/laporan/client",
    name: "LaporanClient",
    component: LaporanClient,
    meta: {
      title: "Laporan Client",
      filter: {
        periode: true
      },
      primary_field: "client",
      noBreadcrumbs: true,
      role: ["ADMIN", "TRAINING", "DIREKSI"]
    }
  },
  {
    path: "/laporan/trainer",
    name: "LaporanTrainer",
    component: LaporanTrainer,
    meta: {
      title: "Laporan Trainer",
      filter: {
        periode: true
      },
      primary_field: "trainer",
      noBreadcrumbs: true,
      role: ["ADMIN", "TRAINING", "DIREKSI"]
    }
  },
  {
    path: "/materi",
    name: "Materi",
    component: Materi,
    meta: {
      filter: {
        laman: true,
        periode: true
      },
      primary_field: "materi",
      role: ["ADMIN", "TRAINING"]
    }
  },
  {
    path: "/trainings/list",
    name: "TrainingList",
    component: Training,
    meta: {
      filter: {
        laman: true,
        periode: true
      },
      primary_field: "training",
      title: "List Training",
      role: ["ADMIN", "TRAINING"]
    }
  },
  {
    path: "/trainings/saya",
    name: "TrainingSaya",
    component: Training,
    meta: {
      filter: {
        laman: true,
        periode: true
      },
      primary_field: "training",
      title: "Training Saya",
      role: ["TRAINING"]
    }
  },
  {
    path: "/trainers/list",
    name: "TrainerList",
    component: Trainer,
    meta: {
      title: "List Trainer",
      filter: {
        laman: true,
        periode: true
      },
      primary_field: "trainer",
      role: ["ADMIN", "TRAINING"]
    }
  },
  {
    path: "/trainers/divisi",
    name: "TrainerDivisi",
    component: TrainerDivisi,
    meta: {
      filter: {},
      primary_field: "trainer_divisi",
      title: "Divisi Trainer",
      role: ["ADMIN", "TRAINING"]
    }
  },
  {
    path: "/clients/list",
    name: "ClientList",
    component: Client,
    meta: {
      filter: {
        laman: true,
        periode: true
      },
      primary_field: "client",
      title: "List Client",
      role: ["ADMIN"]
    }
  },
  {
    path: "/clients/area",
    name: "ClientArea",
    component: ClientArea,
    meta: {
      filter: {
        laman: true
      },
      primary_field: "area",
      title: "Area Client",
      role: ["ADMIN"]
    }
  },
  {
    path: "/user",
    name: "User",
    component: User,
    meta: {
      filter: {
        periode: true
      },
      primary_field: "user",
      noLamanInBreadcrumbs: true,
      role: ["ADMIN"]
    }
  },
  {
    path: "/sistem",
    name: "Sistem",
    component: Sistem,
    meta: {
      filter: {},
      noLamanInBreadcrumbs: true,
      role: ["ADMIN"]
    }
  },
  {
    path: "/profil",
    name: "Profil",
    component: Profil,
    meta: {
      noMenu: true,
      filter: {},
      role: ["ADMIN", "TRAINING", "DIREKSI"]
    }
  },
  // REDIRECT
  {
    path: "*",
    redirect: {
      path: "/404"
    },
    meta: {}
  }
];

export default routes;
